import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import {
  navigationPropType,
  SECONDARY
} from "@template/state/modules/navigation";
import {
  genderPropType,
  FEMALE,
  DEFAULT
} from "@template/state/modules/layout";
import styles from "./index.css";
import SideNavigationContainer from "../SideNavigationContainer";
import Spinner from "../../Spinner";

const cx = classnames.bind(styles);

class SideSecondaryNavigation extends PureComponent {
  state = { animating: "" };

  /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
  componentDidMount() {
    this.secondaryPanel.addEventListener(
      "transitionend",
      ({ target, currentTarget }) => {
        if (target === currentTarget) {
          this.setState({ animating: "" });
        }
      }
    );
  }

  /* istanbul ignore next - dom el eventlistener is not supported in jsdom */
  componentWillUnmmount() {
    this.secondaryPanel.removeEventListener("transitionend");
  }

  renderNavigationPanel = ({ label, id, items }) => (
    <div
      key={id}
      className={cx(styles.item, {
        [styles.item__visible]:
          this.props.navActiveItem === id || this.state.animating === id
      })}
    >
      <section className={styles.header}>
        {this.renderCloseSecondaryButton()}
        <h3 className={styles.h3Text}>{label}</h3>
      </section>
      <nav className={styles.secondary} ref={el => el && (el.scrollTop = 0)}>
        <ul>
          {!items.length ? (
            <Spinner size="x-large" position="centre" />
          ) : (
            items.map(item => (
              <SideNavigationContainer
                key={item.id}
                item={item}
                sideNavLevel={SECONDARY}
              />
            ))
          )}
        </ul>
      </nav>
    </div>
  );

  clearNavActiveItem = () => {
    this.setState({ animating: this.props.navActiveItem });
    this.props.clearNavActiveItem();
    this.props.focusLastActiveElement(this.props.lastActiveElements);
  };

  renderCloseSecondaryButton = () => (
    <button className={styles.closeButton} onClick={this.clearNavActiveItem} />
  );

  saveSecondaryPanel = component => (this.secondaryPanel = component);

  isVisible = () => {
    const { forGender, currentGender, navActiveItem } = this.props;

    return (
      !!navActiveItem &&
      (forGender === currentGender ||
        (forGender === FEMALE && currentGender === DEFAULT))
    );
  };

  render() {
    const { items: groupNavigationItems } = this.props;

    return (
      <div
        className={cx(styles.container, {
          [styles.container__visible]: this.isVisible()
        })}
        ref={this.saveSecondaryPanel}
        aria-hidden={!this.isVisible() ? true : null}
        data-testid="secondary-nav"
      >
        {groupNavigationItems.map(({ items: primaryNavigationItems }) =>
          primaryNavigationItems.map(this.renderNavigationPanel)
        )}
      </div>
    );
  }

  static propTypes = {
    items: PropTypes.arrayOf(navigationPropType).isRequired,
    clearNavActiveItem: PropTypes.func.isRequired,
    navActiveItem: PropTypes.string,
    forGender: genderPropType.isRequired,
    currentGender: genderPropType.isRequired,
    focusLastActiveElement: PropTypes.func.isRequired,
    lastActiveElements: PropTypes.arrayOf(PropTypes.string)
  };
}

export default SideSecondaryNavigation;
